export default value => {
  if (value !== undefined && value != null && value.length > 0) {
    return value
  }
  return "-"
}
